<ng-template #input>
	<ngb-timepicker
		[(ngModel)]="time"
		[ngClass]="{invalid: control.touched && control.errors}"
		[id]="id"
		(ngModelChange)="updateModel()"
		(click)="control.markAsTouched()"
	></ngb-timepicker>
</ng-template>

<ng-template #vertical>
	<div class="input-group col align-items-center">
		<label [for]="id" class="font-weight-600 text-left col-12 p-0">{{label}}</label>

		<div class="input-wrapper col-12 p-0">
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #horizontal>
	<div class="input-group row">
		<label [for]="id" class="font-weight-600 text-right col-3">{{label}}</label>
		<div class="input-wrapper col-9">
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #errors>
	<ng-container *ngIf="control.touched">
		<div [ngClass]="{'control-errors-vertical': template === ControlTemplate.vertical}"
			 class="control-errors col-12" *ngFor="let error of control.errors | keyvalue">
			<span class="error" *transloco="let t">{{ t('generic.' + error.key) }}</span>
		</div>
	</ng-container>
</ng-template>

<ng-container>
	<div [ngSwitch]="template" class="position-relative">
		<ng-container *ngSwitchCase="ControlTemplate.horizontal">
			<ng-container *ngTemplateOutlet="horizontal"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.vertical">
			<ng-container *ngTemplateOutlet="vertical"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.inline">
			<h3 class="text-uppercase text-primary font-weight-700" *ngIf="label">{{label}}</h3>
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</ng-container>
	</div>
</ng-container>
